// gsap sticky image
const gsapOurTeamListingAnimations = () => {
	const wrapper = document.querySelector(
		".wp-block-create-block-our-team-listing",
	);

	const fadeIn = () => {
		const cards = document.querySelectorAll(".team-member-card");

		if (wrapper && cards.length > 0) {
			// Set all cards to opacity 0 initially
			gsap.set(cards, {
				opacity: 0,
			});

			// Use ScrollTrigger.batch for better performance with multiple elements
			ScrollTrigger.batch(cards, {
				start: "top 98%",
				end: "bottom 2%",
				onEnter: (elements) => {
					gsap.to(elements, {
						opacity: 1,
						duration: 1.6,
						ease: "power2.out",
						stagger: 0.15,
					});
				},
				onLeaveBack: (elements) => {
					gsap.set(elements, {
						opacity: 0,
					});
				},
				
				
			});
		}
	};

	fadeIn();
};

if (document.readyState !== "loading") {
	gsapOurTeamListingAnimations();
} else {
	document.addEventListener("DOMContentLoaded", gsapOurTeamListingAnimations);
}
